import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TGetCompanyOnboardingTaskFieldsResponse } from "./getCompanyOnboardingTaskFields.schema";

export const getCompanyOnboardingTaskFields = (axios: IAxiosInstance) => {
  return async () => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetCompanyOnboardingTaskFieldsResponse>
    >("/api/getCompanyOnboardingTaskFields");
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
